import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=46238053&"
import script from "./NewsItem.vue?vue&type=script&lang=coffee&"
export * from "./NewsItem.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports